import chatElements from './chatElements';

const {
  chatContainer,
  initialBox,
} = chatElements;

let isChatInitialized = false;
let currentFlow = null;
let currentQuestionIndex = 0;
let userResponses = JSON.parse(sessionStorage.getItem('scheduleData')) || {};
let isResuming = false;

export function setChatInitialized(value) {
  isChatInitialized = value;
}

export function getChatInitialized() {
  return isChatInitialized;
}

export function saveChatVisibilityState() {
    const isInitialBoxVisible = initialBox.style.display !== 'none';
    const isChatContainerVisible = chatContainer.style.display !== 'none';

    const chatState = {
        visible: isInitialBoxVisible || isChatContainerVisible,
        // showing: isInitialBoxVisible ? 'initial' : 'chat'
        showing: isInitialBoxVisible ? 'initial' : 'initial'
    };

    sessionStorage.setItem('chatVisibility', JSON.stringify(chatState));
}

export function toggleChatVisibility() {
    const isInitial = !getChatInitialized();

    const target = isInitial ? initialBox : chatContainer;
    const currentDisplay = target.style.display;

    target.style.display = currentDisplay === 'none' || currentDisplay === '' 
        ? (isInitial ? 'block' : 'flex') 
        : 'none';

    saveChatVisibilityState();
}

export function loadChatVisibilityState() {
    const saved = sessionStorage.getItem('chatVisibility');
    if (!saved) return;

    const state = JSON.parse(saved);

    if (state.visible) {
        if (state.showing === 'initial') {
            initialBox.style.display = 'block';
            chatContainer.style.display = 'none';
        } else {
            chatContainer.style.display = 'flex';
            initialBox.style.display = 'none';
        }
    } else {
        initialBox.style.display = 'none';
        chatContainer.style.display = 'none';
    }
}

export function setIsResuming(value) {
    isResuming = value;
}

export function getIsResuming() {
    return isResuming;
}

export function setCurrentFlow(flow) {
  currentFlow = flow;
}

export function getCurrentFlow() {
  return currentFlow;
}

// Get the current index
export function getCurrentQuestionIndex() {
  return currentQuestionIndex;
}

// Set the current index
export function setCurrentQuestionIndex(index) {
  currentQuestionIndex = index;
}

// Increment index
export function incrementQuestionIndex() {
  currentQuestionIndex++;
}

// Reset to 0
export function resetQuestionIndex() {
  currentQuestionIndex = 0;
}

// Get the entire object
export function getUserResponses() {
  return { ...userResponses }; // return a copy to prevent direct mutation
}

// Get a specific key
export function getUserResponse(key) {
  return userResponses[key];
}

// Set a specific key
export function setUserResponse(key, value) {
  userResponses[key] = value;
  sessionStorage.setItem('scheduleData', JSON.stringify(userResponses));
}

// Replace the whole object
export function setUserResponses(newResponses) {
  userResponses = { ...newResponses };
  sessionStorage.setItem('scheduleData', JSON.stringify(userResponses));
}

// Clear responses
export function clearUserResponses() {
  userResponses = {};
  sessionStorage.removeItem('scheduleData');
}